// This file is intended to add the non-standard behavior of adding `forEach` on
// HTMLCollection for reverse compatability for custom stories.

import forEach from "core-js/internals/array-for-each";
import createNonEnumerableProperty from "core-js/internals/create-non-enumerable-property";

// This is taken directly from
// https://github.com/zloirock/core-js/blob/master/packages/core-js/modules/web.dom-collections.for-each.js#L16
function handlePrototype(CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach)
    try {
      createNonEnumerableProperty(CollectionPrototype, "forEach", forEach);
    } catch {
      CollectionPrototype.forEach = forEach;
    }
}

handlePrototype(HTMLCollection.prototype);
